import { useSearchParamsState } from 'hooks/useSearchParamState';
import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';
import { setAccessToken, setRefreshToken, setTokenExpiryTime } from 'utils/AuthUtils/tokenUtils';

function getExpiryFromToken(token: string): string {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return new Date(payload.exp * 1000).toUTCString();
  } catch {
    const fallback = new Date();
    fallback.setHours(fallback.getHours() + 24);
    return fallback.toUTCString();
  }
}

const useLoginCallback = () => {
  const {
    UserStore: { setIsAuthenticated, fetchUserDetails }
  } = useStore();
  const [access] = useSearchParamsState('access', '');
  const [refresh] = useSearchParamsState('refresh', '');

  useEffect(() => {
    if (access && refresh) {
      setAccessToken(access);
      setRefreshToken(refresh);
      setIsAuthenticated(true);
      fetchUserDetails();
      setTokenExpiryTime(getExpiryFromToken(access));
      window.location.href = '/job-paste';
    }
  }, []);

  return {};
};

export default useLoginCallback;
